import { put, call, takeEvery, takeLatest, all } from "redux-saga/effects";

import Actions from "../Actions/Creators";
import Types from "../Actions/Types";
import Phi from "../Phi/Phi";
import Constants from "../Phi/Constants";
import { toast } from "react-toastify";
import history from "./../history";

import moment from "moment";

function* handleLogin(action) {
    yield put(
        Actions.loginResponse({
            ok: '',
            error: '',
            errorCode: '',
            message: '',
            isMagicLinkApplied: '',
        })
    );
    yield put(Actions.setLoader())

    const { username, password, otp } = action.payload

    let isGuest = true
    let credentials = { username: 'guest', password: 'KADfa(**#@2' }
    
    if (Boolean(action.payload.username) && Boolean(action.payload.password)) {
        const { username, password } = action.payload;
        credentials = { username, password };
    }else if(otp && otp.length > 3) {
        credentials = {username, otp}
        isGuest = false
    }

    try {
        const response = yield call(Phi.User.login, Phi.User, credentials);
        let userRole = JSON.parse(sessionStorage.getItem('roles'));
        if (action.isGuest) {
            Phi.Storage.setItem("isGuest", 1);
        }
        if (response !== undefined && response.profile !== undefined) {
            // Persistent Login by saving the JWT token in cookies
            if(!Constants.allowedUserRole.includes(userRole[0].role_type_id)){
                // Constants.showToaster("Invalid User", "Error");
                yield put(
                    Actions.loginResponse({
                        ok: false,
                        error: true,
                        errorCode: 401,
                        message: 'Invalid User',
                        isMagicLinkApplied: false,
                    })
                );
            }
            else {
                if (Boolean(action.persistent) && action.persistent.selected) {
                    let cookies = action.persistent.cookies;
                    cookies.set("token", JSON.stringify(Phi.getSession()), { path: "/" });
                    cookies.set("profile", Phi.Storage.getItem("profile"), { path: "/" });
                    cookies.set("custom", Phi.Storage.getItem("custom"), { path: "/" });
                    cookies.set("data", Phi.Storage.getItem("data"), { path: "/" });
                    cookies.set("roles", Phi.Storage.getItem("roles"), { path: "/" });
                }
    
                if (action.isGuest) {
                    Phi.Storage.setItem("isGuest", 1);
                } else {
                    yield put(
                        Actions.loginResponseMagicLink({
                            isMagicLinkUsed: false,
                            isMagicLinkSuccess: false,
                        })
                    );
                    Phi.Storage.setItem("isGuest", 0);
                    Phi.Storage.setItem("isMagicLinkUsed", 0);
                }
    
                yield put(
                    Actions.loginResponse({
                        ok: true,
                        error: false,
                        errorCode: null,
                        setPassword: Boolean(otp),
                        message: "Logged In Successfully",
                        profile: Phi.Storage.getItem("profile"),
                        custom: Phi.Storage.getItem("custom"),
                        data: Phi.Storage.getItem("data"),
                        isMagicLinkApplied: false,
                    })
                );
            }
        } else {
            yield put(
                Actions.loginResponse({
                    ok: false,
                    error: true,
                    errorCode: response.data.status,
                    message: response.data.error,
                    isMagicLinkApplied: false,
                })
            );
        }
    } catch (e) {
        const response = {
            ok: false,
            error: true,
            errorCode: 500,
            message: "Something went wrong",
            isMagicLinkApplied: false,
        };
        yield put(Actions.loginResponse(response));
    }

    yield put(Actions.unsetLoader())
}

function* handleLoginUsingMagicLink(action) {
    yield put(Actions.setLoader());

    let { magicLink, studentId, meta } = action;

    try {
        studentId = parseInt(studentId);
    } catch (e) {
        studentId = null;
    }

    if (!!!magicLink) {
        yield put(
            Actions.loginResponseMagicLink({
                isMagicLinkUsed: true,
                isMagicLinkSuccess: false,
            })
        );
    } else {
        try {
            const response = yield call(Phi.User.magicLinkLogin, Phi.User, { magicLink, type: studentId });

            if (response !== undefined && response.profile !== undefined) {
                // Persistent Login by saving the JWT token in cookies
                if (Boolean(action.persistent) && action.persistent.selected) {
                    let cookies = action.persistent.cookies;
                    cookies.set("token", JSON.stringify(Phi.getSession()), { path: "/" });
                    cookies.set("profile", Phi.Storage.getItem("profile"), { path: "/" });
                    cookies.set("custom", Phi.Storage.getItem("custom"), { path: "/" });
                    cookies.set("data", Phi.Storage.getItem("data"), { path: "/" });
                    cookies.set("roles", Phi.Storage.getItem("roles"), { path: "/" });
                }

                Phi.Storage.setItem("isGuest", 0);
                Phi.Storage.setItem("isMagicLinkUsed", 1);

                yield put(
                    Actions.loginResponseMagicLink({
                        isMagicLinkUsed: true,
                        isMagicLinkSuccess: true,
                        magicLinkMeta: meta,
                        currentStudentId: studentId,
                    })
                );

                yield put(
                    Actions.loginResponse({
                        ok: true,
                        error: false,
                        errorCode: null,
                        setPassword: Boolean(false),
                        message: "Logged In Successfully",
                        profile: Phi.Storage.getItem("profile"),
                        custom: Phi.Storage.getItem("custom"),
                        data: Phi.Storage.getItem("data"),
                        isMagicLinkApplied: true,
                    })
                );
            } else {
                yield put(
                    Actions.loginResponseMagicLink({
                        isMagicLinkUsed: true,
                        isMagicLinkSuccess: false,
                    })
                );
            }
        } catch (e) {
            const response = {
                ok: false,
                error: true,
                errorCode: 500,
                message: "Something went wrong",
                isMagicLinkApplied: true,
            };
            yield put(Actions.loginResponse(response));
            yield put(
                Actions.loginResponseMagicLink({
                    isMagicLinkUsed: true,
                    isMagicLinkSuccess: false,
                })
            );
        }
    }

    yield put(Actions.unsetLoader());
}

function* handleLoginUsingInvitationLink(action) {

    // if(!Phi.User.isGuest() && action.cookies){
        // const cookies = action.cookies
        // cookies.remove('token', {path: '/'})
        // cookies.remove('roles', {path: '/'})

        // yield put(Actions.logoutUser())

        // yield put(Actions.loginUser({},{},true))
    // }

    yield put(Actions.setLoader());

    let { invitationLink } = action;

    if (!!!invitationLink) {
        yield put(
            Actions.loginResponseInvitationLink({
                isInvitationLinkUsed: true,
                isInvitationLinkSuccess: false,
                showInvitationLinkModal: false
            })
        );
    } else {
        const response = yield call(Phi.User.handleLoginUsingInvitationLink, Phi.User, { invitationLink });

        if (response && !response.error) {
            const association = response.association;

            delete response.association;

            yield put(
                Actions.loginResponseInvitationLink({
                    isInvitationLinkUsed: true,
                    isInvitationLinkSuccess: true,
                    isInvitationLinkFailed: false,
                    invitationLink: invitationLink,
                    invitationUserDetails: response,
                    invitationUserAssociations: association,
                    showInvitationLinkModal: true
                })
            );
        }else {
            yield put(
                Actions.loginResponseInvitationLink({
                    isInvitationLinkUsed: true,
                    isInvitationLinkSuccess: false,
                    isInvitationLinkFailed: true,
                    invitationLink: invitationLink,
                    invitationUserDetails: response || {},
                    invitationUserAssociations: [],
                    showInvitationLinkModal: true
                })
            );
        }

    }

    yield put(Actions.unsetLoader());
}

function* handleLogout(action) {
    Phi.User.logout();
    let isAuthenticated = Phi.User.isAuthenticated();
    if (!!isAuthenticated) {
        yield put(Actions.loginResponse({ ok: true, error: false, message: "Logged In" }));
    } else {
        yield put(Actions.loginResponse({ ok: false, error: false, errorCode: 0, message: "Logout User" }));
    }
}

function* handleSignup(action) {
    const { payload } = action;

    let apiParams = {
        username: payload.phone,
        password: payload.password,
        prefix: "HSG",
        profile: [
            {
                id: 1,
                salutation: "",
                firstname: payload.firstName,
                lastname: payload.lastName,
                profile_pic: null,
                dob: null,
                gender: null,
                language_preferences: "English",
            },
        ],
        email: [
            {
                user_email: payload.email,
                user_email_type: 1,
            },
        ],
        phone: [
            {
                user_phone_countrycode: "91",
                user_phone_number: payload.phone,
                user_phone_region_code: "80",
                user_phone_type: 1,
            },
        ],
        address: [
            {
                user_address_no: "",
                user_address_line_1: payload.address,
                user_address_line_2: "",
                city: null,
                state: null,
                zip: null,
                country: null,
                user_address_type: 1,
            },
        ],
        device: "",
        organization: "",
        role: [
            {
                role_type_id: Constants.roleIdMap.DEFAULT_SIGNUP,
            },
        ],
        custom: {
            child_relationship: payload.relationship,
        },
    };

    apiParams.profile = JSON.stringify(apiParams.profile);
    apiParams.email = JSON.stringify(apiParams.email);
    apiParams.phone = JSON.stringify(apiParams.phone);
    apiParams.address = JSON.stringify(apiParams.address);
    apiParams.role = JSON.stringify(apiParams.role);
    apiParams.custom = JSON.stringify(apiParams.custom);

    const response = yield call(Phi.User.addParent, Phi.User, apiParams);

    if (Boolean(response.error)) {
        yield put(Actions.signupResponse({ ok: false, error: true, message: response.error, errorCode: 500 }));
    } else {
        const associationResponse = yield call(Phi.User.addUserAssociationUsingActivationCodeWithoutDOB, Phi.User, {
            email: action.payload.phone,
            activationCode: action.payload.activationCode,
        });

        if (Boolean(associationResponse.error)) {
            yield put(Actions.signupResponse({ ok: false, error: true, message: response.error, errorCode: 500 }));
        }

        //const responseOtp = yield call(Phi.User.sendOtpPhone, Phi.User, payload.phone)

        const credentials = { username: payload.phone, password: payload.password };

        const response = yield call(Phi.User.login, Phi.User, credentials);

        if (response && response.profile) {
            Phi.Storage.setItem("isGuest", 0);

            yield put(
                Actions.signupResponse({
                    ok: true,
                    error: false,
                    message: "Signup Successfully",
                    profile: Phi.Storage.getItem("profile"),
                    custom: Phi.Storage.getItem("custom"),
                    data: response,
                })
            );
        } else {
            yield put(Actions.signupResponse({ ok: false, error: true, errorCode: 403, message: "Signup Failed" }));
        }
    }
}

function* handleSignupV2(action) {
    const { payload, otpInfo } = action;

    let apiParams = {
        username: payload.phone,
        password: payload.password,
        prefix: "HSG",
        profile: [
            {
                id: 1,
                salutation: "",
                firstname: payload.firstName,
                lastname: payload.lastName,
                profile_pic: payload.profilePic,
                dob: Constants.compileUsersDOB(payload.dobDay, payload.dobMonth, payload.dobYear),
                gender: Constants.genderMap[payload.gender],
                language_preferences: "English",
            },
        ],
        email: [
            {
                user_email: payload.email,
                user_email_type: 1,
            },
        ],
        phone: [
            {
                user_phone_countrycode: "91",
                user_phone_number: payload.phone,
                user_phone_region_code: "80",
                user_phone_type: 1,
            },
        ],
        address: [
            {
                user_address_no: "",
                user_address_line_1: "",
                user_address_line_2: "",
                city: null,
                state: null,
                zip: null,
                country: null,
                user_address_type: 1,
            },
        ],
        device: "",
        organization: JSON.stringify([{ organization_id: Constants.covidDeclarationDefaultOrganization }]),
        community: JSON.stringify([{ organization_id: Constants.covidDeclarationDefaultOrganization }]),
        role: [
            {
                role_type_id: Constants.roleIdMap.DEFAULT_SIGNUP,
            },
        ],
        custom: {
            // child_relationship: payload.relationship
            loggedInVia: payload.loggedInVia,
        },
    };

    apiParams.profile = JSON.stringify(apiParams.profile);
    apiParams.email = JSON.stringify(apiParams.email);
    apiParams.phone = JSON.stringify(apiParams.phone);
    apiParams.address = JSON.stringify(apiParams.address);
    apiParams.role = JSON.stringify(apiParams.role);
    apiParams.custom = JSON.stringify(apiParams.custom);

    // const otpResponse = yield put(Actions.handleVerifyUnRegisteredOtp(otpInfo.username, otpInfo.otp, true))

    // if (otpResponse) {

    const response = yield call(Phi.User.addParent, Phi.User, apiParams);

    if (Boolean(response.error)) {
        yield put(Actions.signupResponse({ ok: false, error: true, message: response.error, errorCode: 500 }));
    } else {
        const credentials = { username: payload.phone, password: payload.password };

        const profile = yield call(Phi.User.login, Phi.User, credentials);

        if (profile && profile.profile) {
            Phi.Storage.setItem("isGuest", 0);

            yield put(
                Actions.signupResponse({
                    ok: true,
                    error: false,
                    message: "Signup Successfully",
                    profile: Phi.Storage.getItem("profile"),
                    custom: Phi.Storage.getItem("custom"),
                    data: profile,
                })
            );
            yield put(
                Actions.sendEmail(
                    Constants.communicationMap.EMAILS.MEMBER_SIGNUP_WELCOME.template,
                    Constants.communicationMap.HELPERS.EMAIL_RECIPIENTS([{name: payload.firstName, email: payload.email}]),
                    Constants.communicationMap.HELPERS.EMAIL_VARIABLES({name: payload.firstName, userName: payload.phone})
                )
            )
        } else {
            yield put(Actions.signupResponse({ ok: false, error: true, errorCode: 403, message: "Signup Failed" }));
        }
    }

    // }else {
    //     yield put(Actions.signupResponse({ok: false, error: true, errorCode: 403, message: 'Signup Failed'}));
    // }
}

function* handleSignupV2_1(action) {
    const { payload } = action;

    let apiParams = {
        username: payload.email,
        password: payload.email,
        prefix: "HSG",
        profile: [
            {
                id: 1,
                salutation: "",
                firstname: payload.firstName,
                lastname: payload.lastName,
                profile_pic: payload.profilePic,
                dob: Constants.compileUsersDOB(payload.dobDay, payload.dobMonth, payload.dobYear),
                gender: Constants.genderMap[payload.gender],
                language_preferences: "English",
            },
        ],
        email: [
            {
                user_email: payload.email,
                user_email_type: 1,
            },
        ],
        phone: [
            {
                user_phone_countrycode: "91",
                user_phone_number: payload.phone || "",
                user_phone_region_code: "80",
                user_phone_type: 1,
            },
        ],
        address: [
            {
                user_address_no: "",
                user_address_line_1: "",
                user_address_line_2: "",
                city: null,
                state: null,
                zip: null,
                country: null,
                user_address_type: 1,
            },
        ],
        device: "",
        organization: "",
        role: [
            {
                role_type_id: Constants.roleIdMap.DEFAULT_SIGNUP,
            },
        ],
        custom: {
            // child_relationship: payload.relationship
            loggedInVia: payload.loggedInVia,
        },
    };

    apiParams.profile = JSON.stringify(apiParams.profile);
    apiParams.email = JSON.stringify(apiParams.email);
    apiParams.phone = JSON.stringify(apiParams.phone);
    apiParams.address = JSON.stringify(apiParams.address);
    apiParams.role = JSON.stringify(apiParams.role);
    apiParams.custom = JSON.stringify(apiParams.custom);

    const response = yield call(Phi.User.addParent, Phi.User, apiParams);

    if (Boolean(response.error)) {
        yield put(Actions.signupResponse({ ok: false, error: true, message: response.error, errorCode: 500 }));
    } else {
        // const associationResponse = yield call(Phi.User.addUserAssociationUsingActivationCodeWithoutDOB,Phi.User,{email: action.payload.phone,activationCode: action.payload.activationCode})

        // if(Boolean(associationResponse.error)){
        //     yield put(Actions.signupResponse({ ok: false, error: true, message: response.error, errorCode: 500}))
        // }

        //const responseOtp = yield call(Phi.User.sendOtpPhone, Phi.User, payload.phone)

        const credentials = { username: payload.email, password: payload.email };

        const profile = yield call(Phi.User.socialMediaLogin, Phi.User, credentials);

        if (profile && profile.profile) {
            Phi.Storage.setItem("isGuest", 0);

            yield put(
                Actions.signupResponse({
                    ok: true,
                    error: false,
                    message: "Signup Successfully",
                    profile: Phi.Storage.getItem("profile"),
                    custom: Phi.Storage.getItem("custom"),
                    data: profile,
                })
            );
        } else {
            yield put(Actions.signupResponse({ ok: false, error: true, errorCode: 403, message: "Signup Failed" }));
        }
    }
}

function* updateUser(action) {
    const response = yield call(Phi.User.updateUser, Phi.User, action.payload);

    let fn = Actions.responseUpdateUser;

    if (Boolean(action.next) && Boolean(action.next.action)) {
        fn = action.next.action;
    }

    if (Boolean(response.ok)) {
        //yield put(fn({ status: true }));
        yield put(Actions.updateSelectedChildOnUpdate(action.payload));
    } else {
        yield put(fn({ status: false, error: response.error }));
    }
    
}

function* updateParent(action) {

    let payload = action.payload

    let documentResponse

    if (payload.profilePicObj && typeof payload.profilePicObj === 'object') {
        const s3Credentials = yield call(Phi.Organization.getS3Credentials, Phi.Organization, {acl: ""});
        documentResponse = yield call(Phi.Organization.uploadToS3, payload.profilePicObj, s3Credentials, "user-profile-pictures");
    }
    debugger;

    let possibleName = payload.fullName ;
    let storedName = JSON.parse(sessionStorage.getItem('profile'));
    let firstName , lastName ;
    if ( possibleName && possibleName.split ) {
        // let nameArr = possibleName.split(/\s+/);

        firstName = possibleName.split(" ")[0]
        lastName = possibleName.substring(firstName.length).trim()

        // firstName = nameArr.slice(0, -1).join(" ");
        // lastName = nameArr.pop();
    }
    else {
        firstName = storedName.firstname;
        lastName = storedName.lastname
    }

    let profile = {
        firstname: firstName,
        lastname: lastName ,
        profile_pic:
            documentResponse &&
            documentResponse.headers &&
            documentResponse.headers.location &&
            documentResponse.headers.location.replace
                ? documentResponse.headers.location.replace(/%2F/g, "/")
                : "",
    }
    console.log(profile)
    let email = payload.inEmail ? { id: payload.emailChangeId, user_email: payload.inEmail, user_email_type: 1 } : {}

    Object.keys(profile).forEach(k => (!profile[k]) && delete profile[k]);
    Object.keys(email).forEach(k => (!email[k]) && delete email[k]);


    let updateUser = {
        userid: payload.userId,
        currentUserId: payload.userId,
        username: payload.inEmail,
        password: payload.inPassword,
        description: "Changes done by user from User Profile",
        profile: JSON.stringify([profile]),
        email: JSON.stringify([email]),
    };

    Object.keys(updateUser).forEach(k => (!updateUser[k]) && delete updateUser[k]);


    const response = yield call(Phi.User.updateUser, Phi.User, updateUser);

    if (Boolean(response.ok)) {

        Constants.showToaster("Updated!", "INFO")

        // yield put(Actions.parentUpdateResponse(action.payload));
        yield put(Actions.getUser())
    } else {

        Constants.showToaster("Oops!!! Something went wrong.", "ERROR")

    }
}

function* getUser(action) {
    const response = yield call(Phi.User.get, Phi.User, {
        profile: true,
        email: true,
        phone: true,
        address: true,
        custom: true,
        device: false,
        customer: false,
        organization: true,
        role: true
    });

    if (response && !response.error) {
        yield put(
            Actions.loginResponse({
                ok: true,
                error: false,
                message: "User updated successfully",
                profile: Phi.Storage.getItem("profile"),
                custom: Phi.Storage.getItem("custom"),
                data: Phi.Storage.getItem("data"),
            })
        );
    } else {
        yield put(
            Actions.loginResponse({
                ok: false,
                error: true,
                errorCode: 403,
                message: response.error || "Something went wrong",
            })
        );
    }
}

function* verifyAvailability(action) {
    const params = {
        userName: "null",
        phoneNumber: "0",
        activationCode: "0",
    };

    switch (action.type) {
        case Types.VERIFY_AVAILABILITY_EMAIL: {
            params.userName = action.email;

            const response = yield call(Phi.User.getAvailability, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseAvailabilityEmail({ status: response.user_name_status }));
            } else {
                yield put(Actions.responseAvailabilityEmail({ status: false }));
            }

            break;
        }

        case Types.VERIFY_AVAILABILITY_PHONE: {
            params.phoneNumber = action.phone;

            const response = yield call(Phi.User.getAvailability, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseAvailabilityPhone({ status: response.phone_status }));
            } else {
                yield put(Actions.responseAvailabilityPhone({ status: false }));
            }

            break;
        }

        case Types.VERIFY_AVAILABILITY_CODE: {
            params.activationCode = action.code;
            params.dob = action.dob;

            const response = yield call(Phi.User.getAvailability, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseAvailabilityCode({ status: response.activation_code_status }));
            } else {
                yield put(Actions.responseAvailabilityCode({ status: false }));
            }

            break;
        }
    }
}

//Method is for Checking availabilty Of email,phone,activaitoncode without DOB --- as per New Requirment
function* verifyAvailabilityWithoutDOB(action) {
    yield put(
        Actions.loginResponse({
            ok: '',
            error: '',
            errorCode: '',
            message: '',
            isMagicLinkApplied: '',
        })
    );
    const params = {
        email: "null",
        phoneNumber: "0",
        activationCode: "0",
    };

    var response = "";

    switch (action.type) {
        case Types.CHECK_EMAIL_AVAILABILITY: {
            params.email = action.email;

            response = yield call(Phi.User.getAvailabilityWithoutDOB, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseCheckEmailAvailability({ status: response.email_status }));
            } else {
                yield put(Actions.responseCheckEmailAvailability({ status: false }));
            }

            break;
        }

        case Types.CHECK_PHONE_NUMBER_AVAILABILITY: {
            params.phoneNumber = action.phone;

            response = yield call(Phi.User.getAvailabilityWithoutDOB, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseCheckPhoneNumberAvailability({ status: response.phone_status, meta: response.meta ? JSON.parse(response.meta) : {} }));
            } else {
                yield put(Actions.responseCheckPhoneNumberAvailability({ status: false }));
            }

            break;
        }

        case Types.CHECK_ACTIVATION_CODE_AVAILABILITY: {
            params.activationCode = action.code;

            response = yield call(Phi.User.getAvailabilityWithoutDOB, Phi.User, params);

            if (Boolean(response) && !response.error) {
                yield put(Actions.responseCheckActivationCodeAvailability({ status: response.activation_code_status }));
            } else {
                yield put(Actions.responseCheckActivationCodeAvailability({ status: false }));
            }

            break;
        }
    }
}

//Method Ends HERE

function* changePassword(action) {
    // yield put(Actions.setLoader(`You will be logged out, Please login with the new password`))
    const userid = Phi.User.profile().user_id;
    const isGuest = Phi.User.isGuest()

    const config = { password: action.password, description: "user password changed from forgot password" }
    let response

    if (!isGuest && userid) {
        response = yield call(Phi.User.put, Phi.User, { userid, ...config })
    }
    if (response && !!!response.error) {
        const emptyFormData = { password1: null, password2: null };
        yield put(Actions.initializeForm(emptyFormData));
        if (!!!action.avoidLogout) {
            yield put(Actions.logoutUser());
        }

        Constants.showToaster("Password changed!", "SUCCESS")
    } else {
        Constants.showToaster("Something went wrong, password change failed", "ERROR")
    }
    // yield put(Actions.unsetLoader())
}

// function* updateParentInfo(action){
//     // yield put(Actions.setLoader(`You will be logged out, Please login with the new password`))
//     let config = action.config
//     let studentConfig = action.studentConfig
//     const response = yield call(Phi.User.put, Phi.User, config)
//     const updates = yield call(Phi.User.updateSimilarStudents, Phi.User, studentConfig)

//     let data = Object.assign({});

//     let profile = config.profile ? JSON.parse(config.profile)[0] : null;
//     let phone = config.phone ? JSON.parse(config.phone)[0] : null;
//     let email = config.email ? JSON.parse(config.email)[0] : null;
//     // let custom = JSON.parse(config.newCustom);

//     profile ? data.profile = profile : null;
//     phone ? data.phone = phone : null;
//     email ? data.email = email : null;

//     if (response && !!!response.error) {
//         Constants.showToaster("Information Updated", "INFO");
//         yield put(
//             Actions.parentUpdateResponse({
//                 data,
//                 phone: studentConfig.inPhoneNumber,
//                 email: studentConfig.inPhoneNumber
//             })
//         );
//     } else {
//         Constants.showToaster("Something went wrong!!!", "ERROR");
//     }

//     // if (response && !!!response.error) {
//     //     Constants.showToaster('info', 'Information Updated')
//     // } else {
//     //     Constants.showToaster('error', 'Something went wrong!!!')
//     // }
//     // yield put(Actions.unsetLoader())
// }

// function* handeSendOtp(action) {
//     const email = action.email;
//     const response = yield call(Phi.User.sendOtp, Phi.User, email);
//     if (!response.error && response.username) {
//         Constants.showToaster(`Reset password instructions have been sent to ${response.username}.`, "SUCCESS");
//     }
// }

function* handleSendOtpPhone(action) {
    // const params = {
    //     email: 'null',
    //     phoneNumber: '0',
    //     activationCode: '0'
    // };

    const response = yield call(Phi.User.sendOtpPhone, Phi.User, {
        username: action.username,
        isRegistered: action.isRegistered,
    });

    if (response) {
        yield put(Actions.responseSendOtpPhone({ ok: true }));
    } else {
        yield put(Actions.responseSendOtpPhone({ ok: false }));
    }

    // params.phoneNumber = action.username;
    // let phoneExist = yield call(Phi.User.getAvailabilityWithoutDOB, Phi.User, params);

    // let status = phoneExist.phone_status

    // if(!!!status){
    //     const response = yield call(Phi.User.sendOtpPhone, Phi.User, action.username)

    //     if(response) {
    //         yield put(Actions.responseSendOtpPhone({ok: true}))
    //     }

    //     else {
    //         yield put(Actions.responseSendOtpPhone({ok: false}))
    //     }
    // }else {
    //     yield put(Actions.responseSendOtpPhone({ok: false}))
    // }
}

function* handleVerifyOtp(action) {
    const response = yield call(Phi.User.verifyOtp, Phi.User, { username: action.username, otp: action.otp });

    if (!response.error) {
        yield put(Actions.responseVerifyOtp({ ok: true, error: null }));
    } else {
        yield put(Actions.responseVerifyOtp({ ok: false, error: response.error }));
    }
}

function* handleVerifyUnRegisteredOtp(action) {
    const response = yield call(Phi.User.verifyUnRegisteredOtp, Phi.User, {
        username: action.username,
        otp: action.otp,
        isUpdating: action.isUpdating,
    });

    if (response) {
        yield put(Actions.responseVerifyOtp({ ok: true, error: null }));
        return true;
    } else {
        yield put(Actions.responseVerifyOtp({ ok: false, error: "OTP verification failed" }));
        return false;
    }
}

function* changeValidationResponseType(action) {
    yield put(Actions.responseChangeValidationResponseType({ response: action.str }));
}

function* resetActivationCode(action) {
    yield put(Actions.responseResetActivationCode(action.status));
}

function* addChildUsingActivationCodeWithoutDOB(action) {
    const associationResponse = yield call(Phi.User.addUserAssociationUsingActivationCodeWithoutDOB, Phi.User, {
        email: action.params.email,
        activationCode: action.params.activationCode,
    });

    if (Boolean(associationResponse.error)) {
        yield put(
            Actions.responseAddChildUsingActivationCodeWithoutDOB({
                ok: false,
                error: true,
                message: associationResponse.error,
                errorCode: 500,
            })
        );
    } else {
        yield put(Actions.responseAddChildUsingActivationCodeWithoutDOB({ ok: true }));
    }
}

function* fetchUserSignUpStatus(action) {
    let status = yield call(Phi.User.fetchUserSignUpStatus, Phi.User, { phoneNumber: action.phoneNumber });

    if (!!!status.error) {
        if (status.magicLink) {
            status = {
                ...status,
                magicLink:
                    Constants.apiHost === Constants.stagingAPIHost
                        ? Constants.appBaseURLStaging + "magic-link/" + status.magicLink
                        : Constants.appBaseURLProduction + "magic-link/" + status.magicLink,
            }
        }
        yield put(Actions.storeUserSignUpStatus({ status }));
    } else {
        yield put(Actions.storeUserSignUpStatus({ ok: false }));
    }
}

function* sendMagicLink(action) {
    const { magicLink, email, phone } = action;

    yield (put(Actions.sendEmail(
        Constants.communicationMap.EMAILS.MAGIC_LINK_REQUEST.template,
        Constants.communicationMap.HELPERS.EMAIL_RECIPIENTS([{ name: 'Magic Link', email: email }]),
        Constants.communicationMap.HELPERS.EMAIL_VARIABLES({ MagicLink: magicLink })
    )))

    yield put(Actions.responseMagicLink({ ok: true }));
}

function* sendStudentVerificationEmail(action) {
    const { payload } = action;

    let recipients = [{ name: "Magic Link", email: "arpit.singh@healthsetgo.com", type: "to" }];

    let mailParams = {
        queue: "mail-subscribe",
        payload: {
            template: "parent-login-with-magic-link-forgot-password",
            recipients: recipients,
            vars: [
                { name: "studentId", content: payload.studentId },
                { name: "MagicLink", content: payload.content },
            ],
        },
    };

    const response = yield call(Phi.User.makeACall, Phi.User, mailParams);

    if (response) {
        yield put(Actions.responseMagicLink({ ok: true }));
    } else {
        yield put(Actions.responseMagicLink({ ok: false }));
    }
}

function* putUserAssociation(action) {
    const response = yield call(Phi.User.putUserAssociation, Phi.User, {
        inAssociationJson: JSON.stringify(action.params),
    });

    if (Boolean(response)) {
        //yield put(Actions.responsePutUserAssociation({ ok: false, error: true, message: response.error, errorCode: 500}))
    } else {
        //yield put(Actions.responsePutUserAssociation({ok: true}))
    }
}

function* postParentLinkedIn(action) {
    let accessToken = "";
    let profile = {};
    let { Secrets, code } = action;

    const response = yield call(Phi.User.postUserLinkedInCredentials, Phi.User, {
        host: Secrets.LINKED_IN_LINK_AUTH_HOST,
        uri: Secrets.LINKED_IN_LINK_AUTH_URI(code, encodeURIComponent(window.location.href)),
    });

    if (response && response.profile && response.email) {
        let { email, profile } = response;
        yield put(
            Actions.signupUserV2_1({
                firstName: response.profile.localizedFirstName,
                lastName: response.profile.localizedLastName,
                email: response.email.elements[0]["handle~"].emailAddress,
                profile_pic: null,
                loggedInVia: "LinkedIn",
                password: "Health@123",
            })
        );
    } else {
        Constants.showToaster("Opps! Something went wrong.", "ERROR");
    }
}

function* updateParentInfo(action) {
    // yield put(Actions.setLoader(`You will be logged out, Please login with the new password`))
    let config = action.config;
    const response = yield call(Phi.User.put, Phi.User, config);

    let profile = JSON.parse(config.profile)[0];

    let data = Object.assign({});
    let phone = JSON.parse(config.phone)[0];
    let email = JSON.parse(config.email)[0];

    data.phone = phone;
    data.email = email;
    data.profile = profile;

    if (response && !!!response.error) {
        Constants.showToaster("Information Updated", "INFO");
        yield put(
            Actions.parentUpdateResponse({
                fullName: String(profile.firstname + " " + (profile.lastname || "")).trim(),
                dob: profile.dob || "",
                data,
            })
        );
        yield put(
            Actions.getUser()
        );
    } else {
        Constants.showToaster("Something went wrong!!!", "ERROR");
    }
}

function* postCovidDeclarationForm(action) {
    yield put(Actions.setLoader());

    let file = action.file;
    let documentResponse;

    if (file) {
        const s3Credentials = yield call(Phi.Organization.getS3Credentials, Phi.Organization);
        documentResponse = yield call(Phi.Organization.uploadToS3, file, s3Credentials, "covid-declaration-documents");
    }
    let payload = {
        userId: action.studentId,
        organizationId: action.organizationId,
        type:
            Constants.covidDeclarationFormIdMap[action.roleType] ||
            Constants.covidDeclarationFormIdMap[Constants.roleIdMap.STUDENT],
        declarationForm: JSON.stringify({
            ...action.payload,
            supportingImage: documentResponse ? documentResponse.headers.location : "",
        }),
    };

    const response = yield call(Phi.User.postCovidDeclarationForm, Phi.User, payload);

    if (response && !!!response.error) {
        yield put(
            Actions.getCovidDeclarationList({
                inUserId: action.studentId,
                inOrganizationId: action.organizationId,
                inLimit: 1,
                inOffset: 0,
                startDate: moment().utc().format("yyyy-MM-DD"),
                endDate: moment().utc().format("yyyy-MM-DD"),
            })
        );
        // Constants.showToaster("Information Updated", "INFO");
        yield put(Actions.responseCovidDeclarationForm(true));
    } else {
        yield put(Actions.responseCovidDeclarationForm(false));
        // Constants.showToaster("Something went wrong!!!", "ERROR");
    }

    yield put(Actions.unsetLoader());
}

function* getCovidDeclarationList(action) {
    const response = yield call(Phi.User.getCovidDeclarationList, Phi.User, action.params);

    if (response && response.length) {
        let res = response[0];
        yield put(
            Actions.responseCovidDeclarationList({ count: res.count, declarations: JSON.parse(res.declarations) })
        );
    } else {
        yield put(Actions.responseCovidDeclarationList({}));
    }
}

function* handleInvitationRequest(action) {

    yield put(Actions.setLoader("Sit back and relax while we setup your account"))

    const { payload, associations } = action;

    let useMagicLink = true

    let possibleAssociationInvitation = associations && associations.length ? associations.map(e=>e.inInvitationLink) : []

    let defaultResponse = {
        isInvitationLinkUsed: true,
        isInvitationLinkSuccess: true,
        isInvitationLinkFailed: false,
        invitationLink: payload.invitationLink,
        invitationUserDetails: {},
        invitationUserAssociations: [],
        showInvitationLinkModal: false,
        allowInvitationLinkUpdate: true,
        invitationLinkUpdate: [
            payload.invitationLink || '',
            ...possibleAssociationInvitation,
            payload.inSwitchedInvitationLink || ''
        ],
    }

    const invitationCustom = payload.invitationCustom || {}

    let createUser = {
        username: payload.inMobileNumber || payload.inEmailAddress,
        password: payload.inPassword,
        prefix: "HSG",
        profile: JSON.stringify([{ firstname: payload.inFirstName, lastname: payload.inLastName }]),
        email: JSON.stringify([{ user_email: payload.inEmailAddress, user_email_type: 1 }]),
        phone: payload.inMobileNumber ? JSON.stringify([
            { user_phone_countrycode: "91", user_phone_number: payload.inMobileNumber, user_phone_region_code: "80", user_phone_type: 1 },
        ]) : '',
        organization: JSON.stringify([{ organization_id: payload.organizationId }]),
        community: JSON.stringify([{ organization_id: payload.organizationId }]),
        role: JSON.stringify([{ role_type_id: payload.roleTypeId }]),
        custom: JSON.stringify({ invitationLink: payload.invitationLink, collegeYear: invitationCustom.collegeYear, collegeDepartment: invitationCustom.collegeDepartment, uid: invitationCustom.uid }),
    };

    let updateUser = {
        userid: payload.userId,
        currentUserId: payload.userId,
        username: payload.inMobileNumber || payload.inEmailAddress || null,
        password: payload.inPassword,
        description: "Changes done by user during login using invitation link",
        profile: JSON.stringify([{ firstname: payload.inFirstName, lastname: payload.inLastName }]),
        email:
            payload.refIds.email && payload.inEmailAddress
                ? JSON.stringify([{ id: payload.refIds.email, user_email: payload.inEmailAddress, user_email_type: 1 }])
                : null,
        phone:
            payload.refIds.phone && payload.inMobileNumber
                ? JSON.stringify([{ id: payload.refIds.phone, user_phone_number: payload.inMobileNumber, user_phone_countrycode: "91", user_phone_region_code: "80", user_phone_type: 1 }])
                : null,
        role:
            payload.refIds.role && payload.roleTypeId && [Constants.roleIdMap.TEACHER, Constants.roleIdMap.NON_TEACHING, Constants.roleIdMap.COLLEGE_STUDENT].includes(payload.roleTypeId)
                ? JSON.stringify([{ id: payload.refIds.role, role_type_id: payload.roleTypeId }])
                : null,
        organization:
            payload.refIds.organization && payload.organizationId && [Constants.roleIdMap.TEACHER, Constants.roleIdMap.NON_TEACHING, Constants.roleIdMap.COLLEGE_STUDENT].includes(payload.roleTypeId)
                ? JSON.stringify([{ id: payload.refIds.organization, organization_id: payload.organizationId }])
                : null,
        newCustom: JSON.stringify({ invitationLink: payload.invitationLink, collegeYear: invitationCustom.collegeYear, collegeDepartment: invitationCustom.collegeDepartment }),
    }
    let responseCreate = {}

    if (!payload.userId) {
        responseCreate = yield call(Phi.User.addParent, Phi.User, createUser);
        useMagicLink = false
    }


    if (Boolean(responseCreate.error)) {
        yield put(Actions.signupResponse({ ok: false, error: true, message: responseCreate.error, errorCode: 500 }));
    } else {
        let responseUpdate;

        if (useMagicLink && payload.userId) {
            responseUpdate = yield call(Phi.User.put, Phi.User, updateUser);

            if (responseUpdate && responseUpdate.length) {
                // if (payload.currentOrganizationId) {
                    // yield call(Phi.Organization.addUserCommunityIfDoesNotExist, Phi.User, {organizationId: payload.currentOrganizationId, userId: payload.userId});
                // }
                if (payload.organizationId) {
                    yield call(Phi.Organization.addUserCommunityIfDoesNotExist, Phi.User, {organizationId: payload.organizationId, userId: payload.userId});
                }
            }
        }

        const associationResponse = yield call(Phi.User.postUserInvitationAssociation, Phi.User, {
            inAssociations: JSON.stringify(associations),
            inParentId: responseCreate.id || payload.userId,
        });

        if (associationResponse) {
            if (!useMagicLink && createUser.username && createUser.password){
                const credentials = { username: createUser.username, password: createUser.password };

                // const profile = yield call(Phi.User.login, Phi.User, credentials);

                yield put(Actions.loginUser(credentials))

                // if (profile && profile.profile) {
                //     Phi.Storage.setItem("isGuest", 0);

                //     yield put(
                //         Actions.signupResponse({
                //             ok: true,
                //             error: false,
                //             message: "Signup Successfully",
                //             profile: Phi.Storage.getItem("profile"),
                //             custom: Phi.Storage.getItem("custom"),
                //             data: profile,
                //         })
                //     );
                // } else {
                //     yield put(Actions.signupResponse({ ok: false, error: true, errorCode: 403, message: "Signup Failed" }));
                // }

                yield put(
                    Actions.loginResponseInvitationLink(defaultResponse)
                );

            }else if(payload.magicLink){
                let possibleRedirection = payload.magicLink.match("/magic-link/(.*)")
                if(possibleRedirection && possibleRedirection.length && possibleRedirection[1]) {
                    yield put(Actions.loginUsingMagicLink(possibleRedirection[1], null, {hideForgotPassword: true}))
                    yield put(
                        Actions.loginResponseInvitationLink(defaultResponse)
                    );
                }else{
                    Constants.showToaster("Something went Terribly wrong!!!", "ERROR")
                    yield put(Actions.unsetLoader())
                    Actions.loginResponseInvitationLink({...defaultResponse, allowInvitationLinkUpdate: false, showInvitationLinkModal: true, invitationLinkUpdate: []})
                }
            }else {
                Constants.showToaster("Something went Terribly wrong!!!", "ERROR")
                yield put(Actions.unsetLoader())
                Actions.loginResponseInvitationLink({...defaultResponse, allowInvitationLinkUpdate: false, showInvitationLinkModal: true, invitationLinkUpdate: []})
            }
        }
    }

    // yield put(Actions.unsetLoader())

}

function* putInvitationRequestSuccess(action) {

    let possibleUpdates = action.invitationLink

    if (possibleUpdates && possibleUpdates.asMutable) {
        possibleUpdates = possibleUpdates.asMutable()
    }

    try {
        if (typeof possibleUpdates === 'object' && possibleUpdates && possibleUpdates.length) {
            const linkUsed = possibleUpdates[0]

            yield all(possibleUpdates.map((e, i) => call(Phi.User.putInvitationRequestSuccess, Phi.User, {link: e, status: e === linkUsed ? Constants.activeStatusMap.ACTIVE : Constants.activeStatusMap.DRAFT})))
        }else if (typeof possibleUpdates === 'string' && possibleUpdates) {
            yield call(Phi.User.putInvitationRequestSuccess, Phi.User, {link: possibleUpdates, status: Constants.activeStatusMap.ACTIVE}); 
        }
    }catch (e) {
        if (typeof possibleUpdates === 'object' && possibleUpdates && possibleUpdates.length) {
            yield call(Phi.User.putInvitationRequestSuccess, Phi.User, {link: possibleUpdates[0], status: Constants.activeStatusMap.ACTIVE});
        }
    }
}


function* postInvitationRequest(action) {

    let { inEmail, inName } = action.config

    const response = yield call(Phi.User.postInvitationRequest, Phi.User, action.config);

    if (response && !response.error){
        yield (put(Actions.sendEmail(
            Constants.communicationMap.EMAILS.INVITATION_REQUEST.template,
            Constants.communicationMap.HELPERS.EMAIL_RECIPIENTS([{ name: inName, email: inEmail}]),
            Constants.communicationMap.HELPERS.EMAIL_VARIABLES({ invitationLink: response.invitation, name: inName})
        )))
    }

}

function* postChangeUserLocation(action) {
    const response = yield call(Phi.User.changeUserLocation, Phi.User, action.location);
    if (response && !response.error){
        yield put(Actions.getUser())
    }

}

function* resetLoginResponse() {
    yield put(
        Actions.loginResponse({
            ok: '',
            error: '',
            errorCode: '',
            message: '',
            isMagicLinkApplied: '',
        })
    );   
}

// Saga Watcher
export function* watchUserActions() {
    yield* [
        // takeEvery(Types.SEND_OTP, handeSendOtp),
        takeEvery(Types.LOGIN_USER, handleLogin),
        takeEvery(Types.HANDLE_INVITATION_REQUEST, handleInvitationRequest),
        takeEvery(Types.LOGOUT_USER, handleLogout),
        takeEvery(Types.SIGNUP_USER, handleSignup),
        takeEvery(Types.SIGNUP_USER_V2, handleSignupV2),
        takeEvery(Types.SIGNUP_USER_V2_1, handleSignupV2_1),
        takeEvery(Types.UPDATE_USER, updateUser),
        takeEvery(Types.UPDATE_USER_PROFILE, updateParent),
        takeEvery(Types.VERIFY_AVAILABILITY_EMAIL, verifyAvailability),
        takeEvery(Types.VERIFY_AVAILABILITY_PHONE, verifyAvailability),
        takeEvery(Types.VERIFY_AVAILABILITY_CODE, verifyAvailability),

        takeEvery(Types.CHANGE_PASSWORD, changePassword),
        takeEvery(Types.SEND_OTP_PHONE, handleSendOtpPhone),
        takeEvery(Types.VERIFY_OTP, handleVerifyOtp),
        takeEvery(Types.VERIFY_UNREGISTERED_OTP, handleVerifyUnRegisteredOtp),
        takeEvery(Types.CHANGE_VALIDATION_RESPONSE_TYPE, changeValidationResponseType),
        takeEvery(Types.RESET_ACTIVATION_CODE, resetActivationCode),

        takeLatest(Types.GET_USER, getUser),
        takeEvery(Types.CHECK_EMAIL_AVAILABILITY, verifyAvailabilityWithoutDOB),
        takeEvery(Types.CHECK_PHONE_NUMBER_AVAILABILITY, verifyAvailabilityWithoutDOB),
        takeEvery(Types.CHECK_ACTIVATION_CODE_AVAILABILITY, verifyAvailabilityWithoutDOB),

        takeLatest(Types.ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB, addChildUsingActivationCodeWithoutDOB),
        takeEvery(Types.LOGIN_USING_MAGIC_LINK, handleLoginUsingMagicLink),
        takeEvery(Types.LOGIN_USING_INVITATION_LINK, handleLoginUsingInvitationLink),

        takeLatest(Types.FETCH_USER_SIGNUP_STATUS, fetchUserSignUpStatus),
        takeLatest(Types.SEND_MAGIC_LINK, sendMagicLink),

        takeEvery(Types.PUT_USER_ASSOCIATION, putUserAssociation),
        takeEvery(Types.SEND_STUDENT_VERIFICATION_EMAIL, sendStudentVerificationEmail),

        takeEvery(Types.UPDATE_PARENT_INFO, updateParentInfo),
        takeEvery(Types.POST_PARENT_LINKED_IN, postParentLinkedIn),

        takeEvery(Types.POST_COVID_DECLARATION_FORM, postCovidDeclarationForm),
        takeEvery(Types.GET_COVID_DECLARATION_LIST, getCovidDeclarationList),

        takeEvery(Types.PUT_INVITATION_LINK_SUCCESS, putInvitationRequestSuccess),
        takeEvery(Types.POST_INVITATION_LINK, postInvitationRequest),
        takeEvery(Types.CHANGE__USER__LOCATION, postChangeUserLocation),
        takeEvery(Types.RESET__LOGIN__RESPONSE, resetLoginResponse),

    ];
}